module.exports = __webpack_public_path__ + "img/faq.38c67759.jpg";